var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "报告期限",
                                      prop: "reportDate",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.queryCondition.reportDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "reportDate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.reportDate",
                                        },
                                      },
                                      _vm._l(
                                        _vm.allDate,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3List,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Sponsor",
                                      prop: "sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.sponsorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "sponsorName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.sponsorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "Farm", prop: "farmName" },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.farmName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "farmName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.farmName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "作物",
                                              prop: "cultiVarName",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  filterable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .cultiVarName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "cultiVarName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.cultiVarName",
                                                },
                                              },
                                              _vm._l(
                                                _vm.cropList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.status",
                                                },
                                              },
                                              _vm._l(
                                                _vm.statusOption,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: item.chineseValue,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDUSAGE_ADD,
                    expression: "RMC_PROD_MEDUSAGE_ADD",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.addList },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDUSAGE_DELETE,
                    expression: "RMC_PROD_MEDUSAGE_DELETE",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "danger" },
                on: { click: _vm.onDel },
              },
              [_vm._v("删除")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDUSAGE_SUBMIT,
                    expression: "RMC_PROD_MEDUSAGE_SUBMIT",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.submitData },
              },
              [_vm._v("提交")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDUSAGE_EXPORT,
                    expression: "RMC_PROD_MEDUSAGE_EXPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.exportData },
              },
              [_vm._v("导出")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROD_MEDUSAGE_IMPORT,
                    expression: "RMC_PROD_MEDUSAGE_IMPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.importData },
              },
              [_vm._v("批量导入")]
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "500",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "报告期限",
                "min-width": "100",
                field: "reportDate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.onGrade(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.reportDate))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                field: "category3Name",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Sponsor",
                "min-width": "100",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Farm",
                "min-width": "120",
                field: "farmName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "作物",
                "min-width": "100",
                field: "cultiVarName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "种植亩数",
                "min-width": "100",
                field: "plantUnit",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "实际使用量(kg)",
                "min-width": "120",
                field: "realUse",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.realUse
                              ? scope.row.realUse.toFixed(4)
                              : "0.0000"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "农药原粉量总量(g)/种植亩数(亩)",
                "min-width": "220",
                field: "pesticideUnit",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.pesticideUnit
                              ? scope.row.pesticideUnit.toFixed(4)
                              : "0.0000"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "农药原粉量总量(g)/(亩产量*种植亩数)(ton)",
                "min-width": "300",
                field: "pesticideUnitTotal",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.pesticideUnitTotal
                              ? scope.row.pesticideUnitTotal.toFixed(4)
                              : "0.0000"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "状态",
                "min-width": "100",
                field: "statusI18n",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新人",
                "min-width": "100",
                field: "submitUser",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新日期",
                "min-width": "120",
                field: "submitDate",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "60%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("更新状态 "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "normal",
                            "margin-left": "10px",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("如果无更新时，请先在日期后点击确认")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c("updateDialog", { on: { close: _vm.handleClose } }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "批量导入",
              visible: _vm.dialogBatchUploadVisible,
              width: "40%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogBatchUploadVisible = $event
              },
              close: _vm.onCloseUpload,
            },
          },
          [
            _c(
              "el-row",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c(
                  "el-upload",
                  {
                    ref: "batchUpload",
                    staticStyle: {
                      display: "inline-block",
                      "margin-right": "10px",
                    },
                    attrs: {
                      headers: _vm.header,
                      action: _vm.uploadListsUrl,
                      "on-success": _vm.uploadListsSuccess,
                      "on-error": _vm.uploadError,
                      "on-change": _vm.handleChange,
                      "before-upload": _vm.beforeListsUpload,
                      "file-list": _vm.importFileList,
                      "auto-upload": false,
                      "show-file-list": false,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("选取文件")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    staticStyle: { height: "100%" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadImportTem },
                  },
                  [_vm._v("导入模板下载")]
                ),
              ],
              1
            ),
            _c(
              "el-form",
              { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.uploadForm.fileName,
                        callback: function ($$v) {
                          _vm.$set(_vm.uploadForm, "fileName", $$v)
                        },
                        expression: "uploadForm.fileName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-row", [
              _c("h4", [_vm._v("说明:")]),
              _c("ul", [
                _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
                _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
                _c("li", [
                  _vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M"),
                ]),
                _c("li", [
                  _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
                ]),
                _c("li", [
                  _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onUpload },
                  },
                  [_vm._v("上传")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onClose1 },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }